import './MainLayout.scss';

import { Suspense, useState } from 'react';
import { Layout, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { CenteredState } from '@/components/CenteredState';
import { NewFeaturesModal } from '@/components/features_and_innovations/New_Features_Modal';
import { PageBannerActionsProvider } from '@/components/PageBanner';
import { MobileNavigation } from '@/shared/layout/MobileNavigation';
import { ACCOUNT_ITEM_KEY } from '@/shared/layout/navigation';
import { Sidebar } from '@/shared/layout/Sidebar';
import { SupportModal } from '@/shared/layout/SupportModal';
import { useNavMode } from '@/shared/layout/useNavMode';
import SideMenuItems from '@/shared/utils/SideMenuItems';
import RouteErrorBoundary from '@/utils/ErrorBoundry';
import Navbar from '../../shared/layout/Navbar';

const MainLayout = () => {
  const { t } = useTranslation(['sidebar-menu']);
  const menuItems = SideMenuItems();
  const [isUpdatesModalVisible, setIsUpdatesModalVisible] = useState(false);
  const [isSupportModalVisible, setIsSupportModalVisible] = useState(false);
  // The persisted flag is named `isSidebarOpen` but has always meant "collapsed".
  const isCollapsed = useSelector((state) => state.theme.isSidebarOpen);
  const { mode, isRailForced } = useNavMode(isCollapsed);
  const accountItem = menuItems.find((item) => item.key === ACCOUNT_ITEM_KEY);
  const navigationItems = menuItems.filter((item) => item.key !== ACCOUNT_ITEM_KEY);
  const openUpdates = () => setIsUpdatesModalVisible(true);
  const openSupport = () => setIsSupportModalVisible(true);

  return (
    <div className="c-main-layout" data-nav={mode}>
      {mode !== 'drawer' && (
        <div className="c-main-layout__rail">
          <Sidebar
            items={navigationItems}
            accountItem={accountItem}
            collapsed={mode === 'rail'}
            showToggle={!isRailForced}
            onOpenUpdates={openUpdates}
            onOpenSupport={openSupport}
          />
        </div>
      )}
      <div className="c-main-layout__workspace">
        <Navbar showMenuTrigger={isRailForced} />
        <Layout className="c-main-layout__content">
          <RouteErrorBoundary>
            <PageBannerActionsProvider>
              <Suspense
                fallback={
                  <CenteredState>
                    <Spin />
                  </CenteredState>
                }
              >
                <Outlet />
              </Suspense>
            </PageBannerActionsProvider>
          </RouteErrorBoundary>
        </Layout>
      </div>
      <MobileNavigation
        enabled={isRailForced}
        items={navigationItems}
        accountItem={accountItem}
        onOpenUpdates={openUpdates}
        onOpenSupport={openSupport}
      />
      <NewFeaturesModal
        isUpdatesModalVisible={isUpdatesModalVisible}
        handleCloseUpdatesModal={() => setIsUpdatesModalVisible(false)}
        t={t}
      />
      <SupportModal open={isSupportModalVisible} onClose={() => setIsSupportModalVisible(false)} />
    </div>
  );
};

export default MainLayout;
